var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 43,
    viewBox: "0 0 44 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "facebook-round-svgrepo-com (1) 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M21.8979 0.295898C9.80274 0.295898 0 9.82289 0 21.5778C0 33.3328 9.80274 42.8598 21.8979 42.8598C33.9931 42.8598 43.7958 33.3328 43.7958 21.5778C43.7958 9.82289 33.9931 0.295898 21.8979 0.295898ZM26.7309 17.9699L26.4828 21.1539H23.1211V32.2105H18.8784V21.1539H16.6116V17.9699H18.8784V15.8334C18.8784 14.894 18.9041 13.4392 19.6055 12.533C20.3497 11.577 21.3676 10.9285 23.1211 10.9285C25.9781 10.9285 27.1757 11.3276 27.1757 11.3276L26.6111 14.5864C26.6111 14.5864 25.6702 14.3204 24.7891 14.3204C23.9081 14.3204 23.1211 14.6279 23.1211 15.4842V17.9699H26.7309Z",
    fill: "#FFC185"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_970_25"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 43.7958,
    height: 42.5639,
    fill: "white",
    transform: "translate(0 0.295898)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.c43fa0f3e1f1b12066477d07f97d0cae.svg";
export { ForwardRef as ReactComponent };